// extracted by mini-css-extract-plugin
export default {"text":"overFlow_text__mzcZr"};